<template>
  <div id="defaultId1" class="u4XnOv6 pb20">
    <card
      :class="powerArr[0]?.hasPrivilege ? ' ' : 'vaguesuo'"
      id="g84750"
      class="uj28m1R mb10"
      :isShowLabel="true"
      :label="$t('IndustryNorms.IndustryStatistics')"
      v-if="tableData?.length > 0"
    >
      <div :class="powerArr[0]?.hasPrivilege ? ' ' : 'vague'">
        <el-table
          id="idW4vMUP114514"
          class="Industry uH1RPZr"
          :data="tableData"
          empty-text="No Data"
        >
          <el-table-column
            id="idKo8goB"
            prop="name"
            :width="firstWidth"
            show-overflow-tooltip
            label
            style="border-bottom: 1px solid #cccccc"
          >
          </el-table-column>
          <el-table-column
            id="idcOOd6d"
            v-for="(item, index) in tableDataItem"
            :key="index"
            :prop="item"
            :label="item"
            align="right"
          >
          </el-table-column>
          <!-- <el-table-column id="idLHAngG" prop="2022" :label=" 2022"  align="right">
                </el-table-column>
                <el-table-column id="idcOOd6d" prop="2021" label="2021" align="right">
                </el-table-column>
                <el-table-column id="idLHAngG" prop="2020" label="2020" align="right">
                </el-table-column>
                <el-table-column id="idLHAngG" prop="2019" label="2019" align="right">
                </el-table-column> -->
        </el-table>
      </div>
    </card>
    <card
      id="c4eddc"
      :class="powerArr[1]?.hasPrivilege ? ' ' : 'vaguesuo'"
      class="uj28m1R mb10"
      :isShowLabel="true"
      :label="$t('IndustryNorms.Observations')"
      v-if="ObserData?.length > 0"
    >
      <div :class="powerArr[1]?.hasPrivilege ? ' ' : 'vague'">
        <el-table
          id="ced530"
          class="Industry uH1RPZr"
          :data="ObserData"
          empty-text="No Data"
        >
          <el-table-column
            id="c96d84"
            class="uegVMtq"
            prop="name"
            label
            show-overflow-tooltip
            min-width="200"
            style="border-bottom: 1px solid #ccc"
          >
          </el-table-column>
          <el-table-column
            id="c3b9a1"
            min-width="165"
            class="u8GFkjM"
            prop="Average"
            show-overflow-tooltip
            :label="$t('IndustryNorms.AverageValue')"
            align="right"
          >
          </el-table-column>
          <el-table-column
            id="cd354e"
            min-width="225"
            class="uPdzCgJ"
            prop="Media"
            :label="$t('IndustryNorms.MedianValue')"
            align="right"
          >
          </el-table-column>
          <el-table-column
            id="c026d4"
            min-width="225"
            class="ullp6Ih"
            prop="Max10"
            :label="$t('IndustryNorms.MaximumValue10')"
            align="right"
          >
          </el-table-column>
          <el-table-column
            id="c57533"
            min-width="225"
            class="ui8Zk2n"
            prop="Min10"
            :label="$t('IndustryNorms.MinimumValue10')"
            align="right"
          >
          </el-table-column>
          <el-table-column
            id="cbf47c"
            min-width="225"
            class="ucuQ48p"
            prop="Target"
            :label="$t('IndustryNorms.SubjectCompany')"
            align="right"
          >
          </el-table-column>
        </el-table>
      </div>
    </card>
    <card
      :class="powerArr[2]?.hasPrivilege ? ' ' : 'vaguesuo'"
      :isShowLabel="true"
      :label="$t('IndustryNorms.Performance')"
      class="ability"
      v-if="abilityData?.length > 0"
    >
      <div :class="powerArr[2]?.hasPrivilege ? ' ' : 'vague'">
        <el-table
          id="idW4vMUP1919810"
          class="uH1RPZr table_height_30 table_font_size_14 table_contentHeight_40 table_width_max"
          :data="abilityData"
          :span-method="objectSpanMethod"
          empty-text="No Data"
        >
          <el-table-column
            prop="name"
            label=""
            :width="thirdWidth1"
            show-overflow-tooltip
            class-name="black-backgroundone"
          ></el-table-column>
          <el-table-column
            prop="proportion"
            label=""
            :width="thirdWidth2"
            show-overflow-tooltip
            class-name="black-background"
          >
          </el-table-column>
          <el-table-column
            prop="Average"
            :label="$t('IndustryNorms.AverageValue')"
            min-width="180"
            align="right"
            class-name="white-background"
          >
          </el-table-column>
          <el-table-column
            prop="Media"
            :label="$t('IndustryNorms.MedianValue')"
            align="right"
            min-width="180"
          >
          </el-table-column>
          <el-table-column
            prop="Max10"
            min-width="220"
            :label="$t('IndustryNorms.MaximumValue10')"
            align="right"
          >
          </el-table-column>
          <el-table-column
            prop="Min10"
            min-width="220"
            :label="$t('IndustryNorms.MinimumValue10')"
            align="right"
          >
          </el-table-column>
          <el-table-column
            prop="Target"
            min-width="220"
            :label="$t('IndustryNorms.SubjectCompany')"
            align="right"
          >
          </el-table-column>
        </el-table>
      </div>
    </card>
    <ReLogin :reLoginPop="reLoginVis"></ReLogin>
  </div>
  <!--srcviewscompanydetailsPerformanceIndustryNormsvuehtmlEnd-->
</template>
<script>
// interfaceCode
//importStart

import {
  getCompanyIndustry,
  getPerformanceSummary,
  getIndustryResearchComparison,
  getObservationProject,
  getAbilityPerformance,
} from "@/api/companyApi";
import card from "../../../../components/gui_card/gui_card.vue";
import ReLogin from "../../../../components/ReLogin.vue";
import { getPartPrivilege } from "@/api/companyApi";
//importEnd

export default {
  name: "",
  props: {
    // srcviewscompanydetailsPerformanceIndustryNormsvuePropsStart
    // srcviewscompanydetailsPerformanceIndustryNormsvuePropsEnd
  },
  watch: {
    "$i18n.locale": {
      handler(newVal, oldVal) {
        this.getPerformanceSummaryList();
        this.getlist();
      },
      deep: true, // 深度监听，可以监听对象内部属性的变化
      immediate: true, // 立即执行一次handler函数，即使columns没有变化
    },
  },
  created() {
    const screenWidth = window.innerWidth;
    if (screenWidth < 1650) {
      this.firstWidth = 660 / 1.5 + "px";
      this.thirdWidth1 = 210 / 1.2 + "px";
      this.thirdWidth2 = 390 / 1.5 + "px";
    } else {
      this.thirdWidth1 = 210;
      this.thirdWidth2 = 360;
      this.firstWidth = 540;
    }
  },
  mounted() {
    this.getPerformanceSummaryList();
    this.getPartPrivilegeList();
  },

  components: {
    card,
    ReLogin,
  },

  data() {
    return {
      reLoginVis: false,
      // insertData
      // srcviewscompanydetailsPerformanceIndustryNormsvueDataStart

      // tableData
      tableData: [],
      tableDataItem: [],
      ObserData: [],
      firstWidth: null,
      thirdWidth1: null,
      thirdWidth2: null,
      abilityData: [
        {
          name: "Profitability Ratio",
          proportion: "Return on Equity (%)",
          Average: "",
          Median: "",
          Maximum: "",
          Minimum: "",
          Target: "",
        },
        {
          name: "Profitability Ratio",
          proportion: "Return on Total Assets(%)",
          Average: "",
          Median: "",
          Maximum: "",
          Minimum: "",
          Target: "",
        },
        {
          name: "Profitability Ratio",
          proportion: "Gross Profit Margin(%)",
          Average: "",
          Median: "",
          Maximum: "",
          Minimum: "",
          Target: "",
        },
        {
          name: "Operating Ratio",
          proportion: "Accounts Receivable",
          Average: "",
          Median: "",
          Maximum: "",
          Minimum: "",
          Target: "",
        },
        {
          name: "Operating Ratio",
          proportion: "Current Asset Turnover",
          Average: "",
          Median: "",
          Maximum: "",
          Minimum: "",
          Target: "",
        },
        {
          name: "Operating Ratio",
          proportion: "Total Asset Turnover Rate",
          Average: "",
          Median: "",
          Maximum: "",
          Minimum: "",
          Target: "",
        },
        {
          name: "Structural Ratio",
          proportion: "Current Ratio",
          Average: "",
          Median: "",
          Maximum: "",
          Minimum: "",
          Target: "",
        },
        {
          name: "Structural Ratio",
          proportion: "Quick Ratio",
          Average: "",
          Median: "",
          Maximum: "",
          Minimum: "",
          Target: "",
        },
        {
          name: "Structural Ratio",
          proportion: "Asset Liability Ratio",
          Average: "",
          Median: "",
          Maximum: "",
          Minimum: "",
          Target: "",
        },
        {
          name: "Talent Ratio",
          proportion: "Revenue growth rate",
          Average: "",
          Median: "",
          Maximum: "",
          Minimum: "",
          Target: "",
        },
        {
          name: "Talent Ratio",
          proportion: "Operating Profit Growth Rate",
          Average: "",
          Median: "",
          Maximum: "",
          Minimum: "",
          Target: "",
        },
        {
          name: "Talent Ratio",
          proportion: "Total Asset Growth Rate",
          Average: "",
          Median: "",
          Maximum: "",
          Minimum: "",
          Target: "",
        },
      ],
      powerArr: [],
      manManagementSummary: [],
      // srcviewscompanydetailsPerformanceIndustryNormsvueDataEnd
    };
  },
  methods: {
    getPartPrivilegeList() {
      getPartPrivilege({
        moduleId: this.$route.query.idpower,
      }).then((res) => {
        this.powerArr[0] = res.data.filter((item) => item.id == "462")[0];
        this.powerArr[1] = res.data.filter((item) => item.id == "463")[0];
        this.powerArr[2] = res.data.filter((item) => item.id == "464")[0];
      });
    },
    getPerformanceSummaryList() {
      getPerformanceSummary({ id3a: this.$route.query.id3a })
        .then((res) => {
          if (res.code == 200) {
            this.manManagementSummary = [
              {
                name: this.$t("FinancialHighlight.Revenue"),
                id: this.$t("FinancialHighlight.Revenue"),
                num: res.data.revenue,
              },
              {
                name: this.$t("FinancialHighlight.Profit"),
                id: this.$t("FinancialHighlight.Profit"),
                num: res.data.profit,
              },
              {
                name: this.$t("FinancialHighlight.Growth"),
                id: this.$t("FinancialHighlight.Growth"),
                num: res.data.growth,
              },
              {
                name: this.$t("FinancialHighlight.Liquidity"),
                id: this.$t("FinancialHighlight.Liquidity"),
                num: res.data.liquidity,
              },
              {
                name: this.$t("FinancialHighlight.FinancialStructure"),
                id: this.$t("FinancialHighlight.FinancialStructure"),
                num: res.data.financialStructurt,
              },
              {
                name: this.$t("FinancialHighlight.CreditOpinion"),
                id: this.$t("FinancialHighlight.CreditOpinion"),
                num: res.data.creditOpinion,
              },
              {
                name: this.$t("FinancialHighlight.RiskIndicator"),
                id: this.$t("FinancialHighlight.RiskIndicator"),
                num: res.data.riskIndicatorLower,
              },
              {
                name: this.$t("FinancialHighlight.Solvencyindex"),
                id: this.$t("FinancialHighlight.Solvencyindex"),
                num: res.data.solvencyindexSI,
              },
            ];
            this.$emit("UpdatamarkTotalList", this.manManagementSummary);
          } else {
            this.$emit("UpdatamarkTotalList", []);
          }
        })
        .catch((err) => {
          this.reLoginVis = String(err).includes("403");
        });
      getCompanyIndustry({
        id3a: this.$route.query.id3a,
      }).then((res) => {
        if (res.code == 200) {
          getIndustryResearchComparison({
            isicCode: res.data.isicCode,
            countryCode: this.$route.query.companyCountry,
          }).then((res2) => {
            if (res2.code == 200) {
              this.tableData = res2.data;
              let Arr = Object.keys(res2.data[0]).filter(
                (item) => item != "name",
              );
              this.tableDataItem = this.padArrayToFive(Arr);

              console.log(this.tableDataItem);
            } else {
              this.tableData = [];
            }
          });
          getObservationProject({
            isicCode: res.data.isicCode,
            countryCode: this.$route.query.companyCountry,
            id3a: this.$route.query.id3a,
          }).then((res3) => {
            if (res3.code == 200) {
              this.ObserData = res3.data;
            }
          });
          getAbilityPerformance({
            isicCode: res.data.isicCode,
            countryCode: this.$route.query.companyCountry,
            id3a: this.$route.query.id3a,
          }).then((res4) => {
            if (res4.code == 200) {
              this.abilityData = res4.data;
            } else {
              this.abilityData = [];
            }
          });
        }
      });
    },
    // 数组五位补齐
    padArrayToFive(arr) {
      const targetLength = 5;
      if (arr.length >= targetLength) {
        return arr.slice(0, targetLength); // 超过5个时截取前5个:ml-citation{ref="4" data="citationList"}
      }
      return [...arr, ...Array(targetLength - arr.length).fill("")]; // 不足部分填充空字符串:ml-citation{ref="2,4" data="citationList"}
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      // 只处理第一列
      if (columnIndex === 0) {
        // 获取当前行的 name 值
        const currentName = row.name.replace(/\s+/g, "");
        // 获取上一行的 name 值
        const previousName =
          rowIndex > 0
            ? this.abilityData[rowIndex - 1].name.replace(/\s+/g, "")
            : null;

        // 如果当前行的 name 和上一行的 name 相同
        if (currentName === previousName) {
          return {
            rowspan: 0, // 当前单元格不显示
            colspan: 0, // 当前单元格不显示
          };
        } else {
          // 计算需要合并的行数
          let rowspan = 1;
          for (let i = rowIndex + 1; i < this.abilityData.length; i++) {
            if (this.abilityData[i].name.replace(/\s+/g, "") === currentName) {
              rowspan++;
            } else {
              break; // 一旦遇到不同的 name，就停止
            }
          }
          return {
            rowspan: rowspan, // 合并的行数
            colspan: 1, // 只占用一列
          };
        }
      }
    },
    // srcviewscompanydetailsPerformanceIndustryNormsvueMethodEnd
  },
  computed: {},
};
</script>
<style>
.uj28m1R {
  margin-bottom: 10px;
}

.uH1RPZr {
  width: 100%;
}

.uUIRzUi {
  padding: 30px 40px;
}

.uH1RPZr .black-background {
  background-color: #f2f5f9 !important;
  /* 设置背景色为黑色 */
  color: white;
  /* 设置文本颜色为白色以确保可读性 */
  padding-left: 0.7142857142857143rem !important;
  font-weight: bolder !important;
}

.uH1RPZr .black-backgroundone {
  padding-left: 1.4285714285714286rem !important;
}

.uH1RPZr .el-table__row .white-background {
  background-color: #fff !important;
  /* 设置背景色为黑色 */
  font-weight: 200 !important;
}

.uH1RPZr .el-table__row:hover .white-background {
  background-color: #f2f5f9 !important;
  /* 设置背景色为黑色 */
}

.firstColumn {
  display: block;
  width: 35rem;
  background-color: red;
}

.uH1RPZr.el-table__row {
  height: 80px !important;
}
.uH1RPZr .has-gutter th {
  /* 50 */
  font-size: 18px !important;
  line-height: 30px !important;
  padding: 10px 0px !important;
}
.uH1RPZr .el-table__row td {
  /* 80 */
  font-size: 18px !important;
  line-height: 58px !important;
  padding: 11px 0px !important;
}
.el-table .cell {
  padding-left: 20px;
  padding-right: 20px;
}
.el-table th.el-table__cell > .cell {
  padding-left: 20px;
  padding-right: 20px;
}

@media screen and (max-width: 1920px) {
  .uUIRzUi {
    padding: 22px 30px;
  }
  .head-titel {
    line-height: 24px;
    font-size: 20px;
  }
  .huanggantanhaoicon {
    font-size: 22px;
    margin-left: 6px;
  }
  .riliicon {
    font-size: 22px;
    margin-left: 30px;
  }
  .cuowuicon {
    font-size: 22px;
  }
  .ViewMore {
    line-height: 24px;
    font-size: 16px;
  }
  .ecahrts-header-one .relate-Financial,
  .ecahrts-header-one .relate-left {
    font-size: 16px;
  }
  .Financial-icon-box {
    font-size: 16px;
  }

  .uH1RPZr.el-table__row {
    height: 60px !important;
  }
  .uH1RPZr .has-gutter th {
    /* 50 */
    font-size: 16px !important;
    height: 44px !important;
    padding: 0px !important;
  }
  .uH1RPZr .el-table__row td {
    /* 80 */
    font-size: 16px !important;
    height: 50px !important;
    padding: 0px !important;
  }
  .el-table .cell {
    padding-left: 15px;
    padding-right: 15px;
    font-size: 16px;
  }
  .el-table th.el-table__cell > .cell {
    padding-left: 15px;
    padding-right: 15px;
    font-size: 16px;
  }
}

@media (max-width: 1439px) {
  .uUIRzUi {
    padding: 20px 26px;
  }
  .head-titel {
    line-height: 22px;
    font-size: 18px;
  }
  .huanggantanhaoicon {
    font-size: 20px;
    margin-left: 5px;
  }
  .riliicon {
    font-size: 20px;
    margin-left: 26px;
  }
  .cuowuicon {
    font-size: 20px;
  }
  .ViewMore {
    line-height: 22px;
    font-size: 14px;
  }
  .ecahrts-header-one .relate-Financial,
  .ecahrts-header-one .relate-left {
    font-size: 14px;
  }
  .Financial-icon-box {
    font-size: 12px;
  }

  .uH1RPZr.el-table__row {
    height: 54px !important;
  }
  .uH1RPZr .has-gutter th {
    /* 50 */
    font-size: 12px !important;
    line-height: 20px !important;
    padding: 7px 0px !important;
  }
  .uH1RPZr .el-table__row td {
    /* 80 */
    font-size: 12px !important;
    line-height: 38px !important;
    padding: 8px 0px !important;
  }
  .el-table .cell {
    padding-left: 13px;
    padding-right: 13px;
  }
  .el-table th.el-table__cell > .cell {
    padding-left: 13px;
    padding-right: 13px;
  }
}
</style>
